import { useMemo, useRef, useState } from 'react';
import { Button, Link, Menu, MenuItem } from '@mui/material';
import useRegistry from 'src/hooks/useRegistry';
import { AssessmentLinks } from '../../types';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { getDefaultAssessmentsQueryParams } from '../../helpers/assessments';
import useAuth from 'src/hooks/useAuth';

interface StartAssessmentsButtonProps {
  keyRegistry: string;
  patientId: string;
  additionalQueryParams?: string;
}

const StartAssessmentsButton = ({
  keyRegistry,
  patientId,
  additionalQueryParams,
}: StartAssessmentsButtonProps) => {
  const user = useAuth();
  const anchorElement = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { data: registry } = useRegistry({ filter: { keyRegistry: keyRegistry } });
  const assessmentsLinks: AssessmentLinks[] = useMemo(() => {
    if (!registry) return [];
    try {
      const links = JSON.parse(registry[0].keyValue);
      if (!links.length && links?.link) return [links];
      return links;
    } catch (error) {
      return [];
    }
  }, [registry]);
  if (!patientId) return null;
  return (
    <>
      {assessmentsLinks?.length && (
        <>
          <Button
            ref={anchorElement}
            size="small"
            sx={{ height: '36px' }}
            onClick={() => {
              setIsMenuOpen(true);
            }}
          >
            Start Assessments
          </Button>
          <Menu
            anchorEl={anchorElement.current}
            open={isMenuOpen}
            onClose={() => {
              setIsMenuOpen(false);
            }}
          >
            {assessmentsLinks.map(({ name, link, label }) => {
              const url = `${link}${getDefaultAssessmentsQueryParams(patientId, user)}${
                additionalQueryParams ?? ''
              }`;

              return (
                <MenuItem sx={{ textTransform: 'capitalize' }} key={name + '' + link}>
                  <Link
                    href={url}
                    target={'_blank'}
                    rel={'noopener noreferrer'}
                    color="inherit"
                    display={'flex'}
                  >
                    {label}
                    <OpenInNewIcon sx={{ marginLeft: 2 }} />
                  </Link>
                </MenuItem>
              );
            })}
          </Menu>
        </>
      )}
    </>
  );
};

export default StartAssessmentsButton;
